// extracted by mini-css-extract-plugin
export var root = "FootNotes-module--root--Xn2QB";
export var target = "FootNotes-module--target--9czD8";